import { render, staticRenderFns } from "./CheckConfig.vue?vue&type=template&id=036dc929&"
import script from "./CheckConfig.vue?vue&type=script&lang=js&"
export * from "./CheckConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports